import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

export function useCortanaV2Executor(): boolean {
  return useFeatureFlag(FeatureFlag.cortanaV2Executor);
}
